import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createMemory, deleteMemory, listMemory } from '../api/memory';

export function useMemoryList() {
  return useQuery({ queryKey: ['memory'], queryFn: listMemory });
}

export function useCreateMemory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (content: string) => createMemory(content),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['memory'] }),
  });
}

export function useDeleteMemory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteMemory(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['memory'] }),
  });
}
